import React from 'react';
import { Flex, Loader, Text, Title } from '@gjensidige/builders-components';

import { DiscountItem } from '../Types';

interface Props {
  totalDiscountTitle: string;
  totalDiscountYearly: string;
  isPriceLoading?: boolean;
  discountsList?: DiscountItem[];
}

export default function DiscountDetails({
  totalDiscountTitle,
  totalDiscountYearly,
  isPriceLoading,
  discountsList
}: Props) {
  return (
    <div className="discount-details-wrapper">
      <Flex center="lg" layout="1" className="container-wrapper">
        <div className="discount-details-container">
          {discountsList?.map((discount, index) => (
            <div key={index} className="discount-wrapper">
              <Flex justify="space-between">
                <Text size="body" weight="500">
                  {discount.title}
                </Text>
                <Text size="body" weight="700">
                  {discount.value}
                </Text>
              </Flex>
              <div>
                <Text size="body">{discount.description}</Text>
              </div>
            </div>
          ))}
          <Flex justify="space-between" className="total-discounted-price">
            <Text weight="700" size="body">
              {totalDiscountTitle}
            </Text>
            {isPriceLoading ? (
              <Loader variant="ellipsis" size="sm" />
            ) : (
              <Text weight="700" size="body">
                {totalDiscountYearly}
              </Text>
            )}
          </Flex>
        </div>
      </Flex>
    </div>
  );
}
